/* Tiixo 2026 — storefront behaviour (no dependencies) */
(function () {
  'use strict';
  var TX = window.TX || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = TX.money || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function d(n, p, t, s) {
      var x = (n / 100).toFixed(p).split('.');
      return x[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (x[1] ? s + x[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return d(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(cents, 0, '.', ',');
      return d(cents, 2, ',', '.');
    });
  }
  function moneyNz(cents) { return money(cents).replace(/\.00(?!\d)/, ''); }
  TX.formatMoney = money;

  function toast(msg) {
    var t = $('[data-tx-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }

  /* ---------- panels (drawer, cart, search) ---------- */
  var scrim = $('[data-tx-scrim]');
  var openPanel = null;
  function open(name) {
    var p = $('[data-tx-panel="' + name + '"]');
    if (!p) return;
    if (openPanel && openPanel !== p) close();
    openPanel = p;
    document.documentElement.classList.add('tx-open-' + name);
    p.classList.add('is-open');
    if (name === 'cart') { var u = p.querySelector('[data-tx-unlock]'); if (u) { u.classList.remove('is-run'); void u.offsetWidth; u.classList.add('is-run'); } }
    p.setAttribute('aria-hidden', 'false');
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-on'); }); }
    document.documentElement.style.overflow = 'hidden';
    var f = p.querySelector('input[type=search],input:not([type=hidden]),button');
    if (name === 'search') { var i = p.querySelector('input[type=search]'); if (i) setTimeout(function () { i.focus(); }, 250); }
    else if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 250);
  }
  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('is-open');
    document.documentElement.className = document.documentElement.className.replace(/\s?tx-open-\w+/g, '');
    openPanel.setAttribute('aria-hidden', 'true');
    openPanel = null;
    if (scrim) { scrim.classList.remove('is-on'); setTimeout(function () { if (!openPanel) scrim.hidden = true; }, 350); }
    document.documentElement.style.overflow = '';
  }
  TX.open = open; TX.close = close;
  document.addEventListener('DOMContentLoaded', function () { if (typeof loadRecs === 'function') loadRecs(); });
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-tx-open]');
    if (o) {
      var n = o.getAttribute('data-tx-open');
      if (n === 'cart' && document.body.classList.contains('tpl-cart')) return;
      e.preventDefault(); open(n); return;
    }
    if (e.target.closest('[data-tx-close]') || e.target === scrim) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); closeMegas(); } });

  /* ---------- copy code ---------- */
  function copyCode(el) {
    var code = el.getAttribute('data-tx-copy');
    var done = function () {
      el.classList.add('is-copied');
      var i = el.querySelector('i, .tx-ticket__r, [data-copy-label]');
      if (i) { var old = i.textContent; i.textContent = 'Copied'; setTimeout(function () { i.textContent = old; el.classList.remove('is-copied'); }, 1800); }
      toast('Code ' + code + ' copied');
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else {
      var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      ta.remove(); done();
    }
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-tx-copy]');
    if (c) { e.preventDefault(); e.stopPropagation(); copyCode(c); }
  }, true);
  document.addEventListener('keydown', function (e) {
    var c = e.target.closest && e.target.closest('[data-tx-copy]');
    if (c && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); copyCode(c); }
  });

  /* ---------- header: sticky + mega ---------- */
  var hd = $('[data-tx-header]');
  if (hd) {
    var onScroll = function () { hd.classList.toggle('is-stuck', window.scrollY > 40); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var megaItems = $$('[data-tx-mega]');
  function closeMegas(except) {
    megaItems.forEach(function (li) {
      if (li !== except) { li.classList.remove('is-open'); var a = li.querySelector('.tx-nav__link'); if (a) a.setAttribute('aria-expanded', 'false'); }
    });
  }
  megaItems.forEach(function (li) {
    var a = li.querySelector('.tx-nav__link'); var t;
    function show() { clearTimeout(t); t = setTimeout(function () { closeMegas(li); li.classList.add('is-open'); a.setAttribute('aria-expanded', 'true'); }, 90); }
    function hide() { clearTimeout(t); t = setTimeout(function () { li.classList.remove('is-open'); a.setAttribute('aria-expanded', 'false'); }, 160); }
    li.addEventListener('mouseenter', show);
    li.addEventListener('mouseleave', hide);
    li.addEventListener('focusin', show);
    li.addEventListener('focusout', function (e) { if (!li.contains(e.relatedTarget)) hide(); });
    a.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: none)').matches && !li.classList.contains('is-open')) { e.preventDefault(); closeMegas(li); li.classList.add('is-open'); }
    });
  });
  $$('.tx-nav__item:not([data-tx-mega])').forEach(function (li) { li.addEventListener('mouseenter', function () { closeMegas(); }); });

  /* ---------- countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var cds = $$('[data-tx-countdown]');
  if (cds.length) {
    var tick = function () {
      cds.forEach(function (el) {
        var end = new Date(el.getAttribute('data-tx-countdown') || TX.bf.end).getTime();
        var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        ['d', 'h', 'm', 's'].forEach(function (k) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = pad(v[k]); });
        var c = el.querySelector('[data-compact]');
        if (c) c.textContent = v.d > 0 ? v.d + 'd ' + v.h + 'h ' + pad(v.m) + 'm' : v.h + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's';
        if (s === 0) el.classList.add('is-over');
      });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- cart ---------- */
  var cartBusy = false;
  function renderCart(sections) {
    var html = sections && sections['tx-cart-drawer'];
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-tx-cart]');
    var cur = $('[data-tx-cart]');
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    var n = fresh ? fresh.querySelector('[data-tx-cart-count]') : null;
    if (n) $$('[data-tx-cart-count]').forEach(function (c) { c.textContent = n.textContent; c.setAttribute('data-count', n.textContent.trim()); });
    loadRecs();
  }
  /* cart upsell: 1-2 similar lights when a light is in the cart (Warren 11-03) */
  var recCache = {};
  var LIGHT_TAG = /^offer-(pair-set|pair|size-help)$/;
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function loadRecs() {
    var box = $('[data-tx-cart-recs]');
    if (!box) return;
    var pid = box.getAttribute('data-pid'), inCart = (box.getAttribute('data-in') || '').split(',');
    var got = recCache[pid] ? Promise.resolve(recCache[pid]) :
      fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related').then(function (r) { return r.json(); })
        .then(function (j) { return (recCache[pid] = j.products || []); });
    got.then(function (list) {
      var picks = list.filter(function (p) {
        return p.available && inCart.indexOf(String(p.id)) < 0 && (p.tags || []).some(function (t) { return LIGHT_TAG.test(t); });
      }).slice(0, 2);
      if (!picks.length) { box.hidden = true; return; }
      box.innerHTML = '<p class="tx-recs__h">Pairs well with</p>' + picks.map(function (p) {
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">' : '';
        return '<div class="tx-recs__i"><a class="tx-recs__img" href="' + p.url + '">' + img + '</a><div><a class="tx-recs__t" href="' + p.url + '">' + esc(p.title) + '</a>'
          + '<span class="tx-recs__p">' + money(v.price) + '</span></div><button type="button" class="tx-recs__add" data-tx-rec-add="' + v.id + '">Add</button></div>';
      }).join('');
      box.hidden = false;
    }).catch(function () { box.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tx-rec-add]');
    if (!b) return;
    b.disabled = true; b.textContent = 'Adding';
    /* x-communify-bypass: on a bundle product page the bundle app would otherwise rewrite this add into the page's bundle */
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'x-communify-bypass': 'true' },
      body: JSON.stringify({ id: Number(b.getAttribute('data-tx-rec-add')), quantity: 1, sections: 'tx-cart-drawer', sections_url: window.location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { renderCart(j.sections); })
      .catch(function () { b.disabled = false; b.textContent = 'Add'; toast('Could not add to cart'); });
  });
  function cartReq(url, body) {
    body.sections = 'tx-cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  TX.addToCart = function (form, btn) {
    if (cartBusy) return;
    cartBusy = true;
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) };
    var props = {};
    fd.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    /* free gifts ride on the order (cart attribute), not on a line: one set per order */
    var gifts = props['Free gifts']; delete props['Free gifts'];
    if (Object.keys(props).length) item.properties = props;
    /* single-item format (id/quantity/properties at the top level), not { items: [...] }: Communify's bundle box rewrites
       the top-level id and quantity to the chosen tier, so an items[] list next to them doubled every bundle add (found 11-03) */
    var adding = cartReq(TX.routes.cartAdd + '.js', item).then(function (j) {
      return gifts ? cartReq('/cart/update.js', { attributes: { 'Free gifts': gifts } }) : j;
    });
    return adding
      .then(function (j) {
        renderCart(j.sections);
        if (document.body.classList.contains('tpl-cart')) { window.location.reload(); return; }
        open('cart');
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Could not add to cart'); })
      .then(function () { cartBusy = false; if (btn) btn.classList.remove('is-loading'); });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-tx-quick], [data-tx-product-form]')) {
      e.preventDefault();
      TX.addToCart(f, f.querySelector('[type=submit]'));
    }
  });
  function changeLine(key, qty) {
    var cart = $('[data-tx-cart]');
    if (cart) cart.style.opacity = '.6';
    cartReq(TX.routes.cartChange + '.js', { id: key, quantity: qty })
      .then(function (j) { renderCart(j.sections); })
      .catch(function (err) { toast((err && err.description) || 'Could not update cart'); })
      .then(function () { if (cart) cart.style.opacity = ''; });
  }
  document.addEventListener('click', function (e) {
    var li = e.target.closest('[data-tx-cart] .tx-li');
    if (!li) return;
    var key = li.getAttribute('data-key');
    var input = li.querySelector('[data-tx-line-qty]');
    if (e.target.closest('[data-tx-remove]')) { changeLine(key, 0); return; }
    var q = e.target.closest('[data-tx-qty]');
    if (q && input) { var v = Math.max(0, Number(input.value) + Number(q.getAttribute('data-tx-qty'))); input.value = v; changeLine(key, v); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-tx-cart] [data-tx-line-qty]')) {
      var li = e.target.closest('.tx-li'); changeLine(li.getAttribute('data-key'), Math.max(0, Number(e.target.value)));
    }
  });

  /* ---------- predictive search ---------- */
  var psIn = $('[data-tx-ps-input]'), psOut = $('[data-tx-ps-results]');
  if (psIn && psOut) {
    var psDefault = psOut.innerHTML, psT, psCtl;
    psIn.addEventListener('input', function () {
      var q = psIn.value.trim();
      clearTimeout(psT);
      if (q.length < 2) { psOut.innerHTML = psDefault; return; }
      psT = setTimeout(function () {
        if (psCtl) psCtl.abort();
        psCtl = window.AbortController ? new AbortController() : null;
        var url = TX.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag&section_id=tx-predictive';
        fetch(url, psCtl ? { signal: psCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html');
          var s = d.querySelector('.shopify-section');
          psOut.innerHTML = s ? s.innerHTML : h;
        }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- rails ---------- */
  function initRail(rail) {
    var track = rail.querySelector('.tx-rail__track');
    if (!track) return;
    var root = rail.closest('[data-tx-rail-root]') || rail.parentElement;
    var prev = root.querySelector('[data-tx-prev]'), next = root.querySelector('[data-tx-next]'), bar = rail.querySelector('.tx-rail__bar i');
    function step() { var c = track.children[0]; return c ? c.getBoundingClientRect().width + 20 : track.clientWidth; }
    function upd() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar) {
        var w = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = (w * 100) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 - w) / w) * 100 : 0) + '%)';
      }
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  $$('.tx-rail').forEach(initRail);
  TX.initRail = initRail;

  /* ---------- tabs ---------- */
  $$('[data-tx-tabs]').forEach(function (root) {
    var tabs = $$('[data-tab]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-tab');
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
        $$('[data-panel]', root).forEach(function (p) {
          var on = p.getAttribute('data-panel') === id;
          p.hidden = !on;
          if (on) { var r = p.querySelector('.tx-rail'); if (r && !r._init) { r._init = true; initRail(r); } }
        });
      });
    });
  });

  /* ---------- floating BF bar ---------- */
  var fbar = $('[data-tx-fbar]');
  if (fbar) {
    var dismissed = false;
    try { dismissed = sessionStorage.getItem('tx-fbar') === '1'; } catch (e) {}
    if (!dismissed) {
      var band = $('.tx-band');
      var fb = function () {
        var nearBand = band && band.getBoundingClientRect().top < window.innerHeight;
        var sticky = $('[data-tx-sticky-atc].is-on');
        fbar.classList.toggle('is-on', window.scrollY > 700 && !nearBand && !sticky);
      };
      window.addEventListener('scroll', fb, { passive: true }); fb();
      fbar.querySelector('[data-tx-fbar-x]').addEventListener('click', function () {
        fbar.remove(); try { sessionStorage.setItem('tx-fbar', '1'); } catch (e) {}
      });
    } else fbar.remove();
  }

  /* ---------- delivery estimate + Christmas cut-off ---------- */
  function etNow() {
    var s = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });
    return new Date(s);
  }
  function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  var fmtD = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
  $$('[data-tx-eta]').forEach(function (el) {
    var min = Number(el.getAttribute('data-min')), max = Number(el.getAttribute('data-max')), cut = Number(el.getAttribute('data-cut') || 17);
    var now = etNow();
    var start = new Date(now); start.setHours(12, 0, 0, 0);
    if (!isBiz(now) || now.getHours() >= cut) { start = addBiz(start, 1); }
    var a = addBiz(start, min), b = addBiz(start, max);
    var r = el.querySelector('[data-range]');
    if (r) r.textContent = fmtD(a).replace(/^\w+, /, '') + ' – ' + fmtD(b).replace(/^\w+, /, '');
    var x = el.querySelector('[data-xmas]');
    if (x) {
      var xmas = new Date(now.getFullYear(), 11, 24, 12);
      var d = new Date(xmas), guard = 0;
      while (guard++ < 80) { if (isBiz(d) && addBiz(d, max) <= xmas) break; d.setDate(d.getDate() - 1); }
      var today = new Date(now); today.setHours(12, 0, 0, 0);
      if (today <= d && now < xmas) { x.querySelector('[data-date]').textContent = fmtD(d); x.hidden = false; }
    }
    var cd = el.querySelector('[data-cutoff]');
    if (cd) {
      var target = new Date(now); target.setHours(cut, 0, 0, 0);
      if (!isBiz(now) || now >= target) { target = addBiz(target, 1); target.setHours(cut, 0, 0, 0); }
      var upd = function () {
        var n = etNow(), s = Math.max(0, Math.floor((target - n) / 1000));
        var h = Math.floor(s / 3600), m = Math.floor(s % 3600 / 60);
        cd.textContent = (h > 23 ? Math.floor(h / 24) + 'd ' + (h % 24) + 'h' : h + 'h ' + pad(m) + 'm');
      };
      upd(); setInterval(upd, 30000);
    }
  });

  /* ---------- collection filters (AJAX) ---------- */
  var cg = $('[data-tx-coll]');
  if (cg) {
    var sid = cg.getAttribute('data-section');
    var load = function (url, push) {
      var grid = $('[data-tx-coll-results]');
      if (grid) grid.classList.add('is-loading');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sid).then(function (r) { return r.text(); }).then(function (h) {
        var d = new DOMParser().parseFromString(h, 'text/html');
        ['[data-tx-coll-results]', '[data-tx-coll-tools]', '[data-tx-coll-mf]'].forEach(function (s) {
          var a = d.querySelector(s), b = $(s); if (a && b) b.innerHTML = a.innerHTML;
        });
        if (push) history.replaceState({}, '', url);
        $$('.tx-rail').forEach(initRail);
      }).catch(function () { window.location.href = url; });
    };
    var build = function (form) {
      var p = new URLSearchParams(new FormData(form));
      var del = [];
      p.forEach(function (v, k) { if (v === '') del.push(k); });
      del.forEach(function (k) { p.delete(k); });
      return window.location.pathname + '?' + p.toString();
    };
    document.addEventListener('change', function (e) {
      var f = e.target.closest('form[data-tx-filter]');
      if (!f || e.target.matches('[data-tx-price]')) return;
      load(build(f), true);
    });
    document.addEventListener('submit', function (e) {
      var f = e.target.closest('form[data-tx-filter]');
      if (!f) return;
      e.preventDefault(); load(build(f), true);
      var mf = $('[data-tx-panel="filters"]'); if (mf && mf.classList.contains('is-open')) close();
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-tx-coll] a[data-ajax]');
      if (!a) return;
      e.preventDefault(); load(a.getAttribute('href'), true);
    });
    document.addEventListener('click', function (e) {
      var d = $$('.tx-fd[open]');
      d.forEach(function (x) { if (!x.contains(e.target)) x.removeAttribute('open'); });
    });
  }
  /* load more */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tx-more]');
    if (!b) return;
    e.preventDefault();
    b.classList.add('is-loading');
    fetch(b.getAttribute('href')).then(function (r) { return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html');
      var src = d.querySelector('[data-tx-grid]'), dst = $('[data-tx-grid]');
      if (src && dst) Array.prototype.slice.call(src.children).forEach(function (c) { dst.appendChild(c); });
      var np = d.querySelector('[data-tx-pag]'), cp = $('[data-tx-pag]');
      if (np && cp) cp.innerHTML = np.innerHTML; else if (cp) cp.remove();
    }).catch(function () { window.location.href = b.getAttribute('href'); });
  });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });

  TX.money = TX.money; TX.moneyNz = moneyNz; TX.toast = toast; TX.$$ = $$;
  window.TX = TX;
  document.dispatchEvent(new CustomEvent('tx:ready'));
})();
